export default class Order {
  constructor(API) {
    this.api = API;
  }
  getProviderFromProduct(product) {
    return product.allowedProviders[0].toLowerCase();
  }
  isMonerisEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("moneris") != -1;
  }
  isBraintreeEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("braintree") != -1;
  }
  isStripeEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("stripe") != -1;
  }
  //CC/Skip order
  async preOrder(orderObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/order/pre/common`;
    req.body = orderObj;
    return await req.exec();
  }
  async beginOrder(orderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/order/begin/${provider}`;
    req.body = orderObj;
    return await req.exec();
  }
  async completeOrder(orderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/order/complete/${provider}`;
    req.body = orderObj;
    return await req.exec();
  }
  async refundOrder(orderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/order/refund/${provider}`;
    req.body = orderObj;
    return await req.exec();
  }
  async cancelOrder(orderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/order/cancel/${provider}`;
    req.body = orderObj;
    return await req.exec();
  }
  //Invoice
  async submitInvoiceOrder(orderObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/order/invoice";
    req.body = orderObj;
    return await req.exec();
  }
  async approveInvoiceOrder(orderObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/order/invoice/approve";
    req.body = orderObj;
    return await req.exec();
  }
  async rejectInvoiceOrder(orderObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/order/invoice/reject";
    req.body = orderObj;
    return await req.exec();
  }
  //Get order(s)
  async getOrder(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/order/${externalID}/${orderID}`;
    return await req.exec();
  }
  async getOrderExpanded(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/order/${externalID}/${orderID}?expanded=true`;
    return await req.exec();
  }
  async getOrdersByExternalID(externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/orders/" + externalID;
    return await req.exec();
  }
  async getOrdersFromToTimestamp(from, to) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/orders/report";
    req.appendQueryParam("from", from);
    req.appendQueryParam("to", to);
    return await req.exec();
  }
  async getOrdersByExternalID(externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/orders/" + externalID;
    return await req.exec();
  }
  async getPendingOrders() {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/orders/invoices";
    return await req.exec();
  }
  async getOrderReceipt(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/order/${externalID}/${orderID}/receipt`;
    req.bodyType = "BINARY";
    return await req.exec();
  }
  async getOrderByID(orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/order/${orderID}`;
    return await req.exec();
  }
  async exportOrderRefunds(filterObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/orders/refunds/export`;
    req.bodyType = "JSON/BLOB";
    req.body = { ...filterObj };
    return await req.exec();
  }
  async searchOrderRefunds(filterObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/orders/refunds`;
    req.body = { ...filterObj };
    return await req.exec();
  }
  async updateOrder(externalID, orderID, orderObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = `/order/${externalID}/${orderID}`;
    req.body = orderObj;
    return await req.exec();
  }
  async updateOrderRefund(externalID, orderID, refundedOn, orderRefundObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = `/order/${externalID}/${orderID}/refund/${refundedOn}`;
    req.body = orderRefundObj;
    return await req.exec();
  }
}
